
define('text!templates/modules/feedback/feedback.html',[],function () { return '<div class="feedback-content">\n    <div class="feedback-alert"></div>\n    <div class="feedback-feeling"></div>\n    <div class="feedback-comment"></div>\n</div>\n';});

